import { useAppSelector } from '@user/store/hooks'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import { selectTenantFeatureById } from '@user/store/tenantFeatures'

export function useWWMSSOEnabled() {
  const wwmSSO = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.WWMSSO),
  )

  return wwmSSO?.enabled ?? false
}
